import { TimeFormatOptions, Timestamp } from '@griply/types';
import { format } from 'date-fns';

export const formatTimeRange = (
  start: Timestamp | number,
  end: Timestamp | number,
  timeFormat: TimeFormatOptions,
) => {
  const startDate = new Date(start);
  const endDate = new Date(end);

  const startString = format(startDate, timeFormat);
  const endString = format(endDate, timeFormat);

  const startPeriod = startString.match(/[a-zA-Z]+/)?.[0];
  const endPeriod = endString.match(/[a-zA-Z]+/)?.[0];

  if (startPeriod && endPeriod && startPeriod === endPeriod) {
    return `${startString.replace(startPeriod, '').trim()}-${endString}`;
  }

  return `${startString}-${endString}`;
};
